<template>
  <div id="admin-users-change-pass">
    <Title title="Usuarios"
           subtitle="Cambio de contraseña"/>
    <el-row :justify="'center'">
      <el-col :span="12" :offset="6">
        <el-card id="change-pass-form" class="box-card" shadow="hover">
          <div slot="header" class="clearfix form-title">
            <span>Formulario Cambiar Contraseña</span>
          </div>
          <el-form :model="form" ref="form" status-icon v-loading="loading"
                   :rules="rules">
            <el-form-item label="E-Mail" prop="email">
              <el-input type="email"
                        v-model="form.email"
                        placeholder="Ej: jgallardo@falabella.cl"
                        autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="Contraseña" prop="password">
              <el-input type="password"
                        v-model="form.password"
                        autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="Confirmar Contraseña" prop="verify_pass">
              <el-input type="password"
                        v-model="form.verify_pass"
                        autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         @click="formFunctions.submit(variables)">Enviar</el-button>
              <el-button type="secondary"
                         @click="formFunctions.reset(component)">Limpiar</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { apiRequest } from '@/backend/vue-axios/axios';
import { startRumTiming, getRumDuration, trackBusinessFlow } from '@/observability/datadogRum';
import formFunctions from '../../../mixins/form';
import crud from '../../../mixins/crud';
import permissions from '../../../mixins/permissions';
import Title from '../../components/base/Title.vue';

export default {
  name: 'UserChangePass',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error('las contraseñas no coinciden'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!this.validPassword(value)) {
        callback(new Error('la contraseña debe contener al menos 1 minúscula, mayúscula, número y símbolo especial con una longitud mínima de 10'));
      } else if (!this.validOccurance(value)) {
        callback(new Error('password is weak because its contains series like 123'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      passwordChangeStartedAt: null,
      form: {
        email: '',
        password: '',
        verify_pass: '',
      },
      rules: {
        email: [
          { required: true, message: 'debe ingresar el e-mail' },
          { type: 'email', message: 'debe ingresar un e-mail válido' },
        ],
        password: [
          { required: true, message: 'debe ingresar una contraseña' },
          { validator: validatePassword },
        ],
        verify_pass: [
          { validator: validatePass },
        ],
      },
      component: this,
      form_name: 'form',
      formFunctions,
      variables: {
        component: this,
        module: 'crud',
        service: null,
        pathparam: null,
        condition: null,
        message: {
          error: 'la cuenta no existe, por favor intente nuevamente',
          success: 'La contraseña ha sido modificada',
        },
        params: null,
        next: this.checkAccount,
      },
    };
  },
  components: {
    Title,
  },
  methods: {
    buildPasswordChangeContext(extra = {}) {
      return Object.assign({
        target_user_email: this.form.email || 'unknown',
      }, extra);
    },
    checkAccount() {
      this.passwordChangeStartedAt = startRumTiming();
      this.variables.service = 'get_accounts';
      this.variables.params = {
        accounts_email: this.form.email,
      };
      crud.get.all(this.variables).then((response) => {
        if (response.length === undefined) {
          if (response.active === false) {
            trackBusinessFlow({
              module: 'users',
              flow: 'user_management',
              action: 'change_user_password',
              status: 'blocked',
              durationMs: getRumDuration(this.passwordChangeStartedAt),
              context: this.buildPasswordChangeContext({
                target_user_id: response.id || 'unknown',
                target_account_type: response.account_types_id || 'unknown',
                block_reason: 'inactive_user',
              }),
            });
            this.variables.message.error = `el correo ${this.form.email} se encuentra desactivado, no es posible cambiar la contraseña`;
            formFunctions.error(this.variables);
          } else {
            this.variables.params = {
              id: response.id,
              password: this.form.password,
              email: this.form.email,
              account_types_id: response.account_types_id,
              active: true,
            };
            this.changePass();
          }
        } else {
          trackBusinessFlow({
            module: 'users',
            flow: 'user_management',
            action: 'change_user_password',
            status: 'error',
            durationMs: getRumDuration(this.passwordChangeStartedAt),
            context: this.buildPasswordChangeContext({
              error_message: 'duplicate_account_email',
            }),
          });
          this.variables.message.error = `el correo ${this.form.email} se encuentra duplicado, por favor contactar con Soporte`;
          formFunctions.error(this.variables);
        }
      });
    },
    changePass() {
      this.variables.service = 'update_account';
      if (permissions.apply(this.variables.service, this.variables.params)) {
        this.variables.message.error = 'no se pudo modificar la contraseña, por favor intente nuevamente';
        apiRequest({
          module: this.variables.module,
          service: this.variables.service,
          pathparam: { id: this.variables.params.id },
          params: this.variables.params,
        }).then(() => {
          trackBusinessFlow({
            module: 'users',
            flow: 'user_management',
            action: 'change_user_password',
            status: 'success',
            durationMs: getRumDuration(this.passwordChangeStartedAt),
            context: this.buildPasswordChangeContext({
              target_user_id: this.variables.params.id || 'unknown',
              target_account_type: this.variables.params.account_types_id || 'unknown',
            }),
          });
          formFunctions.success(this.variables, true);
        }).catch((error) => {
          trackBusinessFlow({
            module: 'users',
            flow: 'user_management',
            action: 'change_user_password',
            status: 'error',
            durationMs: getRumDuration(this.passwordChangeStartedAt),
            context: this.buildPasswordChangeContext({
              target_user_id: this.variables.params.id || 'unknown',
              target_account_type: this.variables.params.account_types_id || 'unknown',
              error_message: error.response && error.response.data
                ? error.response.data.message
                : 'unknown_error',
            }),
          });
          formFunctions.error(this.variables);
        });
      } else {
        trackBusinessFlow({
          module: 'users',
          flow: 'user_management',
          action: 'change_user_password',
          status: 'blocked',
          durationMs: getRumDuration(this.passwordChangeStartedAt),
          context: this.buildPasswordChangeContext({
            target_user_id: this.variables.params.id || 'unknown',
            target_account_type: this.variables.params.account_types_id || 'unknown',
            block_reason: 'permission_denied',
          }),
        });
        this.variables.message.error = 'no tiene permiso para modificar este tipo de cuenta';
        formFunctions.error(this.variables);
      }
    },
    validPassword(val) {
      const passw = /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).{10,20}$/;
      return passw.test(val);
    },
    validOccurance(val) {
      const aToz = '0123456789';
      let s = '';
      for (let i = 0; i < val.length; i++) { // Mohan@1234
        for (let j = i; j < val.length; j++) {
          s += val.charAt(j);
          if (s.length > 2) {
            if (aToz.includes(s)) {
              return false;
            }
          }
        }
        s = '';
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
